import React from "react";
import "../styles/Home.css";
import HeroBanner from "../content/homeData/heroBanner/HeroBanner";
import AboutMBR from "../content/homeData/aboutMbr/AboutMBR";
import ServiceSection from "../content/homeData/serviceSection/ServiceSection";
import WhyChooseMbr from "../content/homeData/whyChooseMbr/WhyChooseMbr";
import CareerResources from "../content/homeData/careerResources/CareerResources";
import JoinCommunity from "../content/homeData/joinCommunity/JoinCommunity";
import ContactSection from "../content/homeData/contactSection/ContactSection";
import HomeHeroSection from "../content/homeData/homeHeroSection/HomeHeroSection";

function Home() {
  return (
    <>
      
      <HomeHeroSection />
      <HeroBanner />
      <AboutMBR />
      {/* <ServiceSection /> */}
      <WhyChooseMbr />
      <CareerResources />
      <JoinCommunity />
      {/* <ContactSection /> */}
    </>
  );
}

export default Home;
